import Toast from "shared/toast";
import Flash from "shared/flash";

export function clearNotifications() {
  Flash.hide();
  Toast.clear();
}
